import { useEffect, useState } from "react";
import styles from "./TopNav.module.css";

/**
 * Top nav — quiet. Sits above the hero with no background, then gains
 * a paper bar + ink underline once the user has scrolled past the hero
 * fold. Intentionally minimal — wordmark on the left, four anchors on
 * the right, no megamenu.
 */
export function TopNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={scrolled ? styles.navScrolled : styles.nav}
      aria-label="Primary"
    >
      <div className={`atlasContainer ${styles.inner}`}>
        {/* Anchors are written as `/#section` (not bare `#section`) so
            they resolve from sub-pages like /stickies. On the homepage
            browsers treat them as in-page jumps with no reload. */}
        <a className={styles.brand} href="/" aria-label="Atlas Desk — home" />
        <ul className={styles.links}>
          <li>
            <a href="/#philosophy">Philosophy</a>
          </li>
          <li>
            <a href="/#apps">Apps</a>
          </li>
          <li>
            <a href="/#layouts">Layouts</a>
          </li>
          <li>
            <a href="/#download" className={styles.cta}>
              Download
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
